import once from '@lib/once';

function initSubcategorySelectDropdown(triggerBtn, dropdown) {
    triggerBtn.dataset.productCategoryPageInitialized = 'true';

    triggerBtn.addEventListener('click', toggle);

    document.addEventListener('click', (e) => {
        if (!triggerBtn.contains(e.target) && !dropdown.contains(e.target) && isOpen()) {
            toggle();
        }
    });

    function isOpen() {
        return dropdown.classList.contains('is-visible');
    }

    function toggle() {
        dropdown.classList.toggle('is-visible');
        triggerBtn.dataset.isOpen = isOpen().toString();
    }
}

function initProductCategoryGallery(gallery) {
    const bullets = gallery.querySelectorAll('.slider-bullet');
    const count = bullets.length;
    const sliderInterval = gallery.dataset.sliderInterval;
    let intervalId;
    const setAutoChange = () => {
        clearInterval(intervalId);
        intervalId = setInterval(() => {
            const active = gallery.dataset.sliderActive + 1;
            const next = active >= count ? 0 : active;
            bullets.item(next).click();
        }, sliderInterval);
    };

    setAutoChange();

    bullets.forEach((bullet) => {
        bullet.addEventListener('click', (e) => {
            const index = e.target.dataset.bulletNumber;
            const images = gallery.querySelectorAll('img');
            gallery.querySelector('img.active').classList.remove('active');
            images.item(index).classList.add('active');
            gallery.dataset.sliderActive = index;
            setAutoChange();
        });
    });
}

window.Drupal.behaviors.productCategoryPage = {
    attach: (context) => {
        const triggerBtn = context.querySelector('.product-category-page__headline.has-subcategories');
        const dropdown = context.querySelector('.product-category-page__subcategories');
        once('productSubcategoryDropdownSelect', initSubcategorySelectDropdown, [triggerBtn, dropdown]);
    },
};

window.Drupal.behaviors.productCategoryGallery = {
    attach: (context) => {
        const gallery = context.querySelector('.product-category-page__gallery');
        if (gallery) {
            once('productCategoryGallery', initProductCategoryGallery, [gallery]);
        }
    },
};
